export const systemManager = {
  system: null,
};
